module.exports = __webpack_public_path__ + "img/1.88c86e2a.jpg";